import Component from '../core/Component'


export default class InputUpload extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            inner: null,
            fileList: null
        }

        this.fileNames = []
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
    }

    handleChange = event => {
        this.appendInputToList(event.target)
        this.createNewInput()
    }

    createNewInput() {
        const div = document.createElement('div')
        div.innerHTML = `<input class="InputUpload-input" input="files[]" type="file" id="file${this.fileNames.length}">`

        this.ref.inner.prepend(div.firstChild)
    }

    appendInputToList(input) {
        const files = [...input.files]

        if (files.length < 1) {
            return
        }
        const fileName = files[0].name

        const itemElement = document.createElement('div')
        itemElement.classList.add('InputUpload-item')

        itemElement.innerHTML = `
                <button type="button" class="InputUpload-remove"><span class="Icon Icon--crossTiny"></span></button>
                <span class="InputUpload-fileName">${fileName}</span>
                `
        input.tabIndex = '-1'
        itemElement.prepend(input)

        itemElement.querySelector('.Icon--crossTiny').addEventListener('click', () => itemElement.parentNode.removeChild(itemElement))


        this.ref.fileList.appendChild(itemElement)
        this.fileNames.push(fileName)
    }
}